import { APIClient } from "./apiCore";
import * as url from "./urls";

const api = new APIClient();

export const postInsQna = (data) =>
  api.createWithFile(url.POST_NUMBA_INSQNA, data);
export const postQnaList = (data) => api.create(url.POST_NUMBA_QNALIST, data);
export const noticeList = (data) => api.create(url.POST_NUMBA_NOTICELIST, data);
export const faqList = (data) => api.create(url.POST_NUMBA_FAQLIST, data);
export const postDelQna = (data) => api.create(url.POST_NUMBA_DELQNA, data);
export const postUpdQna = (data) => api.createWithFile(url.POST_NUMBA_UPDQNA, data);

export const postReviewList = (data) => api.create(url.POST_NUMBA_REVIEWLIST, data);
export const postReviewDetail = (data) => api.create(url.POST_NUMBA_SELREVIEW, data);
export const postInsReview = (data) => api.createWithFile(url.POST_NUMBA_INSREVIEW, data);
export const postInsReviewComment = (data) => api.create(url.POST_NUMBA_INSREVIEW_C, data);
export const postUpdReview = (data) => api.createWithFile(url.POST_NUMBA_UPDREVIEW, data);
export const postUpdReviewComment = (data) => api.create(url.POST_NUMBA_UPDREVIEW_C, data);
export const postDelReview = (data) => api.create(url.POST_NUMBA_DELREVIEW, data);